import { render, staticRenderFns } from "./perfectMoneyForm.vue?vue&type=template&id=47197d23&scoped=true"
import script from "./perfectMoneyForm.vue?vue&type=script&lang=js"
export * from "./perfectMoneyForm.vue?vue&type=script&lang=js"
import style0 from "./perfectMoneyForm.vue?vue&type=style&index=0&id=47197d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47197d23",
  null
  
)

export default component.exports